import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaWideNavless } from '@xing-com/layout-tokens';

export const SectionGridContainer = styled(GridContainer)`
  max-width: unset;
`;

export const ButtonContainer = styled(GridItem)`
  display: flex;
  justify-content: start;
  align-items: start;
  @media ${mediaWideNavless} {
    justify-content: end;
  }
`;
